@let data = tableData();
@switch (data.type) {
@case(DATA_DISPLAY_TYPES.string){
<span [attr.title]="data.value" class="mat-body-medium">{{data.value}}</span>
}
@case(DATA_DISPLAY_TYPES.img){
<div class="image-wrapper">
	<img [src]="data.src" />
</div>
}
@case(DATA_DISPLAY_TYPES.status){
<app-status-chip [statusType]="data.status.statusType" [translatedValue]="data.status.translationInfoDisplayName"
	[value]="data.status.displayName" />
}
@case(DATA_DISPLAY_TYPES.date){
@if(this.currentLocale()){
<span [attr.title]="data.date" class="mat-body-medium">{{data.date | date:'shortDate' : "" :
	currentLocale()!.value}}</span>
}
}
@case(DATA_DISPLAY_TYPES.edit){
<button mat-icon-button (click)="onActionClick()">
	<ogs-m3-icon icon="edit" />
</button>
}
@case(DATA_DISPLAY_TYPES.duration){
<time class="mat-body-medium">{{data.duration | appDuration}}</time>
}
@case(DATA_DISPLAY_TYPES.boolean){
@if (data.value){
<span class="mat-body-medium">{{"Ja" | translate : "label-yes" : "shared/bcl-table-data"}}</span>
}
@else {
<span class="mat-body-medium">{{"Nein" | translate : "label-no" : "shared/bcl-table-data"}}</span>
}
}
@case(DATA_DISPLAY_TYPES.localizedString){
@let localizedString = (data.translationInfo.defaultText | translate : data.translationInfo.token);
<span [attr.title]="localizedString" class="mat-body-medium">{{localizedString}}</span>
}
@case(DATA_DISPLAY_TYPES.datePeriod){
<span class="mat-body-medium">{{data.datePeriod | appDatePeriod}}</span>
}
@case(DATA_DISPLAY_TYPES.timePeriod){
<span class="mat-body-medium">{{data.timePeriod | appTimePeriod}}</span>
}
}
